import React from 'react';
import { useNavigate } from 'react-router-dom';

const ADMIN_USERNAMES = ['nate', 'lisie'];

function getIsAdmin(): boolean {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return false;
    const user = JSON.parse(userStr);
    return ADMIN_USERNAMES.includes((user.username || '').toLowerCase());
  } catch {
    return false;
  }
}

interface TopBarProps {
  difficulty: 'basic' | 'hard';
  onDifficultyChange: (value: 'basic' | 'hard') => void;
  onNewGame: () => void;
  onLogout: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ difficulty, onDifficultyChange, onNewGame, onLogout }) => {
  const navigate = useNavigate();
  const isAdmin = getIsAdmin();

  return (
    <div className="app-header">
      <div className="app-title">Guess the Word</div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <select
          value={difficulty}
          onChange={(e) => onDifficultyChange(e.target.value as 'basic' | 'hard')}
          className="secondary-button"
        >
          <option value="basic">Basic words</option>
          <option value="hard">Hard words</option>
        </select>
        <button className="primary-button" onClick={onNewGame}>New game</button>
        {isAdmin && (
          <button className="secondary-button" onClick={() => navigate('/admin')}>Admin</button>
        )}
        <button className="secondary-button" onClick={onLogout}>Log out</button>
      </div>
    </div>
  );
};

export default TopBar;
